import { render, staticRenderFns } from "./Baike.vue?vue&type=template&id=a4df3c40&scoped=true"
import script from "./Baike.vue?vue&type=script&lang=js"
export * from "./Baike.vue?vue&type=script&lang=js"
import style0 from "./Baike.vue?vue&type=style&index=0&id=a4df3c40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4df3c40",
  null
  
)

export default component.exports